<template>
  <generic-modal :modal-key="'welcome_sign_up'"
                 :hasExtraModalClass="'modal modal--welcomeback modal--zero-balance'"
                 :classStyle="'modal__content modal_welcome modal_cont'"
                 :idProp="'modal_no_spinning'"
                 @close="$emit('close')">
    <template slot="content">
      <div class="modal__body">
<!--        <div class="logo_form"><img :src="getTranslations.logo_for_branded_projects || 'static/images/Swipo_logo_02.png'" alt=""></div>-->
        <h1>{{ getTranslations.home_modals_welcome_sign_up_welcome }}</h1>

        <p class="upper_section_modal">{{ getTranslations.home_modals_welcome_sign_up_proof_your_knowledge }}</p>
        <img class="modal_icon_main" src="static/images/resub-prize.png" alt="">

      </div>
      <div class="modal__footer"><span class="terms">
          <span class="make_it_bold">{{ getTranslations.home_modals_welcome_sign_up_note }}</span>
        {{ getTranslations.home_modals_welcome_sign_up_do_not_forget }}<br>
      </span>
      </div>
    </template>
  </generic-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import GenericModal from '../sharedcomponents/GenericModal';

export default {
  name: 'welcome-signup',
  components: { GenericModal },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/WelcomeSignup.vue